import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import ErrorBoundary, { ErrorBoundaryStateProps, ErrorBoundaryDispatchProps } from "./ErrorBoundary";
import { logout } from "../../store/session/actions";
import { monitorError } from "../../ajax/requests";

const mapStateToProps = (state: ApplicationState): ErrorBoundaryStateProps => ({
    
});

const mapDispatchToProps = (dispatch: AppThunkDispatch): ErrorBoundaryDispatchProps => ({
    onError: (error, errorInfo) => dispatch((_, getState) => {
        monitorError(error, errorInfo, getState())
        dispatch(logout())
        setTimeout(() => { location.reload() }, 2000)
    }),
});

export default connect<ErrorBoundaryStateProps, ErrorBoundaryDispatchProps, void, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ErrorBoundary as any);